import { mappingApi } from "@iventis/api/src/api";
import { translate } from "@iventis/translations/translation";
import { Content } from "@iventis/translations";
import { MapExportApiCreateRequest } from "@iventis/domain-model/model/mapExportApiCreateRequest";

export const exportMap = async (exportOptions: MapExportApiCreateRequest, mapId: string) =>
    mappingApi.post<unknown, void, MapExportApiCreateRequest>(`maps/${mapId}/exports`, exportOptions, {
        customErrorMessage: {
            title: translate(Content.errors.custom_network_error.export_error.title, { entity: translate(Content.map9.plan) }),
            message: translate(Content.errors.custom_network_error.export_error.message, { entity: translate(Content.map9.plan) }),
        },
    });
